export const setPublicClientBase = (baseUrl: string) => {
  localStorage.setItem("apiBase", baseUrl);
};

export const getPublicClientBase = (): string | null =>
  localStorage.getItem("apiBase");

export const getToken = () => getQueryParam("token");

export const getQueryParam = (param: string): string => {
  const queryParams = new URLSearchParams(window.location.search);
  const queryParam = queryParams.get(param);
  return queryParam ?? "";
};

export const validateSignedUrl = async (
  url: string
): Promise<{ status: number; body: any }> => {
  const endpoint = `${getPublicClientBase()}/DocumentData/W8form/login`;

  const urlModel = {
    Url: url,
  };

  const options = {
    method: "POST",
    body: JSON.stringify(urlModel),
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(endpoint, options);

  const data = await response.json();

  return {
    status: response.status,
    body: data,
  };
};
